import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { ForwardedRef } from "react";
import { forwardRefWithGeneric } from "../utils";

export interface CardHeaderProps {}

const CardHeader = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<CardHeaderProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, ...rest } = props;
  const Component = as ?? "div";

  return (
    <Component {...rest} ref={ref} className={twMerge("p-4", className)} />
  );
};

export default forwardRefWithGeneric(CardHeader);
